// 2P AI — scheda Server (§8.2). Semaforo verde/rosso da node_ok (il giallo "degradato" resta
// inattivo: l'API non fornisce metriche CPU/disco). "Apri" filtra i progetti di quella macchina.
import type { ReactNode } from 'react';
import { useLocation } from 'wouter';
import { useServers, useProjects, useSessions } from '../lib/queries';
import { isOpen } from '../lib/sessions';
import { ServerCard } from '../components/ServerCard';
import { NewCard } from '../components/NewCard';
import type { SemaforoState } from '../components/ServerSemaforo';

export function ServersTab({ onOpenServer }: { onOpenServer: (id: string) => void }) {
  const [, navigate] = useLocation();
  const servers = useServers().data ?? [];
  const projects = useProjects().data ?? [];
  const sessions = useSessions().data ?? [];

  const okCount = servers.filter((s) => s.node_ok).length;
  const offCount = servers.length - okCount;

  function summary(serverId: string): ReactNode {
    const own = projects.filter((p) => p.server_id === serverId);
    const projIds = new Set(own.map((p) => p.id));
    const active = sessions.filter((s) => projIds.has(s.project_id) && isOpen(s.status)).length;
    if (own.length === 0) return <span className="lo">nessun progetto</span>;
    return (
      <>
        {own.length} {own.length === 1 ? 'progetto' : 'progetti'} · {active > 0 ? <span className="hi">{active} attive</span> : <span className="lo">0 attive</span>}
      </>
    );
  }

  return (
    <>
      <div className="scr-title">Server</div>
      <div className="scr-sub">
        {servers.length} {servers.length === 1 ? 'macchina' : 'macchine'} · {okCount} ok{offCount > 0 ? `, ${offCount} offline` : ''}
      </div>
      <section className="grid">
        {servers.map((s) => {
          const state: SemaforoState = s.node_ok ? 'green' : 'red';
          return <ServerCard key={s.id} server={s} state={state} off={!s.node_ok} summary={summary(s.id)} onOpen={() => onOpenServer(s.id)} onConfig={() => navigate(`/server/${s.id}/config`)} />;
        })}
        <NewCard label="Nuovo server" onClick={() => navigate('/server/new/config')} />
      </section>
    </>
  );
}
